import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

import { getJwt } from '@app/helpers';
import api from '../api';

const controller = "crfCicloOrcamentario";

export interface CrfCicloOrcamentario {
    id: string;
    nome: string;
    descricao: string;
    ano: number;
}

export interface CrfCicloOrcamentarioHasJoinProjeto {
    nomeTipoProjetoPrevisao: string;
    id: string;
    nome: string;
    numero: string;
    codigo: string;
    areaId: number;
    departamentoId: number;
    diretoriaId: number;
    escopoAnual: string;
    nomeArea: string;
    nomeDepartamento: string;
    nomeDiretoria: string;
    id_Finplan: string;
}

export interface CrfCicloOrcamentarioJoinProjeto {
    projetoId: string;
    crfCicloOrcamentarioId: string;
}

export const getAllCrfCicloOrcamentario = () => api.get<CrfCicloOrcamentario[]>(`${controller}`);

export const createCrfCicloOrcamentario = (ciclo: CrfCicloOrcamentario) => {
    return api.post<CrfCicloOrcamentario>(`${controller}`, ciclo);
};

export const updateCrfCicloOrcamentario = (ciclo: CrfCicloOrcamentario) =>
    api.put<CrfCicloOrcamentario>(`${controller}/${ciclo.id}`, ciclo);

export const getAllCrfCicloOrcamentarioHasTap = (crfCicloOrcamentarioId: string) =>
    api.get<CrfCicloOrcamentarioHasJoinProjeto[]>(`${controller}/${crfCicloOrcamentarioId}/projetos`);

export const createPlanilhaTpaCrfCicloOrcamentario = (id: string, file: any, ciclo: CrfCicloOrcamentario) => {
    const form = new FormData();

    form.append('file', file);
    form.append('id', id);
    form.append('descricao', ciclo.descricao);
    form.append('ano', ciclo.ano.toString());

    return api.post(`crfTap/createTap`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const exportaCrfCicloOrcamentarioAno = (id: string) => {
    let urlBase = window.location.origin;

    const url = `${urlBase}/api/${controller}/${id}/projetos/exportar`;

    trackPromise(Axios.get(url,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "relatorioCrfCicloOrcamentario.xlsx");
            link.setAttribute('id', 'relatorioCrfCicloOrcamentarioId');
            document.body.appendChild(link);
            link.click();
            let element = document.getElementById('relatorioCrfCicloOrcamentarioId');
            if (element) {
                element.outerHTML = '';
            }
        })
    );
};

export const crfCicloOrcamentarioJoinProjeto = (crfCicloOrcamentarioId: string, join: CrfCicloOrcamentarioJoinProjeto) => {
    return api.post<CrfCicloOrcamentarioJoinProjeto>(`${controller}/${crfCicloOrcamentarioId}/projetos/join`, join);
};
